
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.11.0
 * Query Engine version: efd2449663b3d73d637ea1fd226bafbcf45b3102
 */
Prisma.prismaVersion = {
  client: "5.11.0",
  engine: "efd2449663b3d73d637ea1fd226bafbcf45b3102"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  previewId: 'previewId',
  logo: 'logo',
  name: 'name',
  description: 'description',
  tagline: 'tagline',
  createdAt: 'createdAt',
  slug: 'slug',
  userId: 'userId',
  isVerified: 'isVerified',
  isSponsored: 'isSponsored',
  isPublished: 'isPublished',
  isClaimed: 'isClaimed',
  launchedAt: 'launchedAt',
  viewsCount: 'viewsCount',
  companyName: 'companyName',
  hqLocation: 'hqLocation',
  industriesServed: 'industriesServed',
  productOffering: 'productOffering',
  targetCustomers: 'targetCustomers'
};

exports.Prisma.VoteScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  createdAt: 'createdAt',
  userId: 'userId',
  productV2Id: 'productV2Id'
};

exports.Prisma.CommentScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  userId: 'userId',
  commentText: 'commentText',
  createdAt: 'createdAt',
  isFirstComment: 'isFirstComment'
};

exports.Prisma.ProductMetaDataScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  email: 'email',
  websiteLink: 'websiteLink',
  companyLinkedIn: 'companyLinkedIn',
  stageOfFundraise: 'stageOfFundraise',
  problemSolving: 'problemSolving',
  problemSolution: 'problemSolution',
  productAccomplish: 'productAccomplish',
  communityContact: 'communityContact',
  demoVideo: 'demoVideo',
  helpNeeded: 'helpNeeded',
  topFeatures: 'topFeatures',
  productDifferentiation: 'productDifferentiation',
  screenshots: 'screenshots'
};

exports.Prisma.ProductPrivateDataScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  revenue: 'revenue',
  teamSizeMin: 'teamSizeMin',
  teamSizeMax: 'teamSizeMax',
  pitchDeck: 'pitchDeck',
  burnRate: 'burnRate'
};

exports.Prisma.FounderScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  linkedIn: 'linkedIn',
  name: 'name',
  photo: 'photo',
  role: 'role'
};

exports.Prisma.CustomerReviewScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  customerName: 'customerName',
  reviewText: 'reviewText',
  photo: 'photo'
};

exports.Prisma.CategoryScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.ParentCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  slug: 'slug',
  icon: 'icon'
};

exports.Prisma.SubCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  slug: 'slug',
  icon: 'icon',
  parentCategoryId: 'parentCategoryId'
};

exports.Prisma.RegionScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.ProductsCategoriesScalarFieldEnum = {
  productId: 'productId',
  categoryId: 'categoryId'
};

exports.Prisma.ProductsParentCategoriesScalarFieldEnum = {
  productId: 'productId',
  parentCategoryId: 'parentCategoryId'
};

exports.Prisma.ProductsSubCategoriesScalarFieldEnum = {
  productId: 'productId',
  subCategoryId: 'subCategoryId'
};

exports.Prisma.ProductsRegionsScalarFieldEnum = {
  productId: 'productId',
  regionId: 'regionId'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  oauth_token: 'oauth_token',
  oauth_token_secret: 'oauth_token_secret',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  founderId: 'founderId',
  createdAt: 'createdAt',
  signedUpFromUrl: 'signedUpFromUrl',
  deletedAt: 'deletedAt',
  isBlocked: 'isBlocked',
  metaData: 'metaData'
};

exports.Prisma.UserProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  username: 'username',
  previousUsername: 'previousUsername',
  bio: 'bio',
  gender: 'gender',
  jobTitle: 'jobTitle',
  location: 'location',
  company: 'company',
  howDoYouIdentifyYourself: 'howDoYouIdentifyYourself',
  coverImage: 'coverImage',
  isVerified: 'isVerified',
  isFounder: 'isFounder',
  updatedAt: 'updatedAt',
  verifiedAt: 'verifiedAt',
  userTypes: 'userTypes',
  personalWebsite: 'personalWebsite',
  linkedin: 'linkedin',
  instagram: 'instagram',
  twitter: 'twitter',
  viewsCount: 'viewsCount'
};

exports.Prisma.UserUpgradeScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  upgradedTo: 'upgradedTo',
  upgradedBy: 'upgradedBy',
  status: 'status',
  createdAt: 'createdAt'
};

exports.Prisma.IncognitoProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  profilePicture: 'profilePicture',
  username: 'username',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.FollowingProfilesScalarFieldEnum = {
  userId: 'userId',
  followingProfileId: 'followingProfileId',
  followedAt: 'followedAt'
};

exports.Prisma.FollowingParentCategoriesScalarFieldEnum = {
  userId: 'userId',
  followingParentCategoryId: 'followingParentCategoryId',
  followedAt: 'followedAt'
};

exports.Prisma.FollowingFamiliesScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  followingSlug: 'followingSlug',
  followedAt: 'followedAt'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.ProductLaunchesScalarFieldEnum = {
  id: 'id',
  launchDate: 'launchDate',
  productId: 'productId'
};

exports.Prisma.DaySpotLightScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  votes: 'votes',
  productV2Id: 'productV2Id'
};

exports.Prisma.AdminScalarFieldEnum = {
  id: 'id',
  email: 'email'
};

exports.Prisma.AnalyticsScalarFieldEnum = {
  id: 'id',
  pageId: 'pageId',
  viewsCount: 'viewsCount'
};

exports.Prisma.NewsLetterScalarFieldEnum = {
  id: 'id',
  email: 'email',
  createdAt: 'createdAt'
};

exports.Prisma.FeedbackScalarFieldEnum = {
  id: 'id',
  rating: 'rating',
  aboutTheSite: 'aboutTheSite',
  whatCouldBeBetter: 'whatCouldBeBetter',
  userId: 'userId',
  createdAt: 'createdAt'
};

exports.Prisma.TrendingNewsScalarFieldEnum = {
  id: 'id',
  text: 'text',
  link: 'link',
  region: 'region',
  updatedAt: 'updatedAt'
};

exports.Prisma.CategoryLeaderScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  userType: 'userType',
  categoryType: 'categoryType',
  categorySlug: 'categorySlug'
};

exports.Prisma.LeaderBoardScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  position: 'position'
};

exports.Prisma.UserNotificationsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  notificationType: 'notificationType',
  text: 'text',
  link: 'link',
  senderId: 'senderId',
  isRead: 'isRead',
  createdAt: 'createdAt'
};

exports.Prisma.EventScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  title: 'title',
  timezone: 'timezone',
  description: 'description',
  image: 'image',
  coverImage: 'coverImage',
  tagline: 'tagline',
  link: 'link',
  location: 'location',
  type: 'type',
  level: 'level',
  isVisible: 'isVisible',
  isPrivate: 'isPrivate',
  inviteCode: 'inviteCode',
  dateTime: 'dateTime',
  endDateTime: 'endDateTime',
  isFeatured: 'isFeatured',
  externalLink: 'externalLink',
  totalRegistrations: 'totalRegistrations',
  totalViews: 'totalViews',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rawEventData: 'rawEventData',
  communityId: 'communityId',
  channelId: 'channelId',
  authorId: 'authorId',
  organizerName: 'organizerName',
  tags: 'tags'
};

exports.Prisma.EventRegistrationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  role: 'role',
  email: 'email',
  eventId: 'eventId',
  leftAt: 'leftAt',
  createdAt: 'createdAt'
};

exports.Prisma.OnlineUserScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  lastActive: 'lastActive'
};

exports.Prisma.ChatScalarFieldEnum = {
  id: 'id',
  uniqueId: 'uniqueId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  channelId: 'channelId'
};

exports.Prisma.ChatReportScalarFieldEnum = {
  id: 'id',
  reporterId: 'reporterId',
  chatId: 'chatId',
  reason: 'reason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChatInfoScalarFieldEnum = {
  id: 'id',
  logo: 'logo',
  description: 'description',
  startTime: 'startTime',
  endTime: 'endTime',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chatId: 'chatId'
};

exports.Prisma.ChatRulesScalarFieldEnum = {
  id: 'id',
  chatId: 'chatId',
  rule: 'rule',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChatLinkedPageScalarFieldEnum = {
  id: 'id',
  chatId: 'chatId',
  pageId: 'pageId',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChatReadStatusScalarFieldEnum = {
  id: 'id',
  chatId: 'chatId',
  userId: 'userId',
  isRead: 'isRead',
  messages: 'messages',
  previousMessages: 'previousMessages',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.PinnedChatScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  chatId: 'chatId',
  pinnedAt: 'pinnedAt'
};

exports.Prisma.MessagesScalarFieldEnum = {
  id: 'id',
  messageText: 'messageText',
  iv: 'iv',
  senderId: 'senderId',
  chatId: 'chatId',
  isEdited: 'isEdited',
  totalReactions: 'totalReactions',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.MessageReactionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  userId: 'userId',
  messageId: 'messageId',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.BlockedUserFromChatScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  chatId: 'chatId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VentureCapitalScalarFieldEnum = {
  id: 'id',
  name: 'name',
  logo: 'logo',
  tagline: 'tagline',
  about: 'about',
  slug: 'slug',
  hqLocation: 'hqLocation',
  website: 'website',
  linkedin: 'linkedin',
  foundedYear: 'foundedYear',
  totalCompanies: 'totalCompanies',
  totalInvestmentAmount: 'totalInvestmentAmount',
  totalExits: 'totalExits',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  viewsCount: 'viewsCount',
  rank: 'rank'
};

exports.Prisma.InvestmentStageTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FundTypeTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SectorFocusTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VentureCapitalCompanyScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  logo: 'logo',
  description: 'description',
  hqLocation: 'hqLocation',
  lastRoundFundingAmount: 'lastRoundFundingAmount',
  lastRoundFundingTimestamp: 'lastRoundFundingTimestamp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productId: 'productId',
  productV2Id: 'productV2Id'
};

exports.Prisma.VentureCapitalTeamScalarFieldEnum = {
  id: 'id',
  name: 'name',
  image: 'image',
  role: 'role',
  company: 'company',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  venturCapitalId: 'venturCapitalId',
  userId: 'userId'
};

exports.Prisma.VentureCapitalsCompaniesScalarFieldEnum = {
  id: 'id',
  venturCapitalId: 'venturCapitalId',
  venturCapitalCompanyId: 'venturCapitalCompanyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VentureCapitalsInvestmentStageTagsScalarFieldEnum = {
  id: 'id',
  venturCapitalId: 'venturCapitalId',
  investmentStageTagId: 'investmentStageTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VentureCapitalsFundTypeTagsScalarFieldEnum = {
  id: 'id',
  venturCapitalId: 'venturCapitalId',
  fundTypeTagId: 'fundTypeTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VentureCapitalsSectorFocusTagsScalarFieldEnum = {
  id: 'id',
  venturCapitalId: 'venturCapitalId',
  sectorFocusTagId: 'sectorFocusTagId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DeviceTokenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  token: 'token',
  rawDeviceInfo: 'rawDeviceInfo',
  lastActive: 'lastActive',
  createdAt: 'createdAt'
};

exports.Prisma.PlatformOptionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  value: 'value'
};

exports.Prisma.MediaScalarFieldEnum = {
  id: 'id',
  entity: 'entity',
  entityId: 'entityId',
  name: 'name',
  alternativeText: 'alternativeText',
  caption: 'caption',
  width: 'width',
  height: 'height',
  ext: 'ext',
  mime: 'mime',
  size: 'size',
  path: 'path',
  order: 'order',
  provider: 'provider',
  providerMetaData: 'providerMetaData',
  isDeleted: 'isDeleted',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PostMediaScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  type: 'type',
  objectPath: 'objectPath',
  alt: 'alt',
  metadata: 'metadata',
  isDeleted: 'isDeleted',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PostCommentMediaScalarFieldEnum = {
  id: 'id',
  commentId: 'commentId',
  type: 'type',
  objectPath: 'objectPath',
  alt: 'alt',
  metadata: 'metadata',
  isDeleted: 'isDeleted',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TaggedProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  entityId: 'entityId',
  entityType: 'entityType',
  taggedAt: 'taggedAt'
};

exports.Prisma.TaggedProductScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  entityId: 'entityId',
  entityType: 'entityType',
  taggedAt: 'taggedAt',
  productV2Id: 'productV2Id'
};

exports.Prisma.CommunityScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  about: 'about',
  description: 'description',
  logo: 'logo',
  coverImage: 'coverImage',
  welcomeMessage: 'welcomeMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isExternal: 'isExternal',
  totalPosts: 'totalPosts',
  totalChannels: 'totalChannels',
  totalMembers: 'totalMembers',
  totalViews: 'totalViews',
  settings: 'settings',
  rawMetaData: 'rawMetaData',
  rawCommunityData: 'rawCommunityData'
};

exports.Prisma.CommunityMemberScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  communityId: 'communityId',
  channelId: 'channelId',
  pseudoRoleName: 'pseudoRoleName',
  role: 'role',
  bannedAt: 'bannedAt',
  kickedAt: 'kickedAt',
  lastActiveAt: 'lastActiveAt',
  joinedAt: 'joinedAt',
  leftAt: 'leftAt',
  bannedById: 'bannedById',
  kickedById: 'kickedById',
  rawMemberData: 'rawMemberData'
};

exports.Prisma.CommunityMembershipRequestScalarFieldEnum = {
  id: 'id',
  communityId: 'communityId',
  channelId: 'channelId',
  userId: 'userId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CommunityInviteScalarFieldEnum = {
  id: 'id',
  invitedById: 'invitedById',
  invitedUserId: 'invitedUserId',
  email: 'email',
  communityId: 'communityId',
  role: 'role',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  channelId: 'channelId'
};

exports.Prisma.CommunityLogScalarFieldEnum = {
  id: 'id',
  communityId: 'communityId',
  channelId: 'channelId',
  content: 'content',
  createdAt: 'createdAt'
};

exports.Prisma.ChannelScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  description: 'description',
  about: 'about',
  logo: 'logo',
  coverImage: 'coverImage',
  welcomeMessage: 'welcomeMessage',
  screeningQuestions: 'screeningQuestions',
  hideFromOtherFeeds: 'hideFromOtherFeeds',
  authorId: 'authorId',
  communityId: 'communityId',
  parentChannelId: 'parentChannelId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  order: 'order',
  totalPosts: 'totalPosts',
  totalMembers: 'totalMembers',
  totalViews: 'totalViews',
  settings: 'settings',
  rawMetaData: 'rawMetaData',
  rawChannelData: 'rawChannelData',
  isArchived: 'isArchived',
  deletedAt: 'deletedAt',
  isPaid: 'isPaid',
  paymentType: 'paymentType',
  price: 'price',
  discount: 'discount',
  customPaymentLink: 'customPaymentLink',
  stripeProductId: 'stripeProductId',
  paymentSettings: 'paymentSettings'
};

exports.Prisma.ChannelNotificationSettingScalarFieldEnum = {
  id: 'id',
  channelId: 'channelId',
  settings: 'settings',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChannelGuidelineScalarFieldEnum = {
  id: 'id',
  channelId: 'channelId',
  image: 'image',
  title: 'title',
  description: 'description'
};

exports.Prisma.PostScalarFieldEnum = {
  id: 'id',
  title: 'title',
  content: 'content',
  legacyContent: 'legacyContent',
  customContent: 'customContent',
  version: 'version',
  slug: 'slug',
  authorId: 'authorId',
  channelId: 'channelId',
  communityId: 'communityId',
  pinned: 'pinned',
  postType: 'postType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  resharedPostId: 'resharedPostId',
  rawMetaData: 'rawMetaData',
  rawPostData: 'rawPostData',
  deletedAt: 'deletedAt',
  totalViews: 'totalViews',
  totalReactions: 'totalReactions',
  totalShares: 'totalShares'
};

exports.Prisma.PinnedPostScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  type: 'type',
  createdAt: 'createdAt'
};

exports.Prisma.PostReactionScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  userId: 'userId',
  type: 'type',
  createdAt: 'createdAt'
};

exports.Prisma.PostCommentScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  content: 'content',
  legacyContent: 'legacyContent',
  customContent: 'customContent',
  version: 'version',
  postId: 'postId',
  authorId: 'authorId',
  parentCommentId: 'parentCommentId',
  totalViews: 'totalViews',
  totalReactions: 'totalReactions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rawCommentData: 'rawCommentData',
  rawMetaData: 'rawMetaData'
};

exports.Prisma.PostCommentReactionScalarFieldEnum = {
  id: 'id',
  commentId: 'commentId',
  userId: 'userId',
  type: 'type',
  createdAt: 'createdAt'
};

exports.Prisma.PressFormResponseScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  orgName: 'orgName',
  orgWebsite: 'orgWebsite',
  contactEmail: 'contactEmail',
  releaseDate: 'releaseDate',
  title: 'title',
  content: 'content',
  attachmentUrls: 'attachmentUrls',
  howDoYouKnowUs: 'howDoYouKnowUs',
  priority: 'priority',
  promotion: 'promotion',
  seo: 'seo',
  total: 'total',
  paid: 'paid',
  paymentId: 'paymentId',
  sessionId: 'sessionId',
  podcast: 'podcast',
  optGuranteedPublish: 'optGuranteedPublish',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  logo: 'logo',
  adminEmail: 'adminEmail',
  stageOfFundraise: 'stageOfFundraise',
  companySize: 'companySize',
  yearFounded: 'yearFounded',
  tagline: 'tagline',
  about: 'about',
  categories: 'categories',
  customCategories: 'customCategories',
  businessModel: 'businessModel',
  faqs: 'faqs',
  revenue: 'revenue',
  rawCompanyData: 'rawCompanyData',
  investors: 'investors',
  contactEmail: 'contactEmail',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  companyLocationId: 'companyLocationId'
};

exports.Prisma.CompanyLocationScalarFieldEnum = {
  id: 'id',
  country: 'country',
  city: 'city',
  state: 'state',
  fullAddress: 'fullAddress',
  pincode: 'pincode',
  latLng: 'latLng'
};

exports.Prisma.CompanySocialLinkScalarFieldEnum = {
  id: 'id',
  website: 'website',
  linkedIn: 'linkedIn',
  twitter: 'twitter',
  facebook: 'facebook',
  instagram: 'instagram',
  youtube: 'youtube',
  vimeo: 'vimeo',
  companyId: 'companyId'
};

exports.Prisma.InvestorScalarFieldEnum = {
  id: 'id',
  name: 'name',
  companyId: 'companyId'
};

exports.Prisma.ProductV2ScalarFieldEnum = {
  id: 'id',
  previewId: 'previewId',
  slug: 'slug',
  name: 'name',
  sameAsCompanyName: 'sameAsCompanyName',
  tagline: 'tagline',
  description: 'description',
  logo: 'logo',
  industriesServed: 'industriesServed',
  features: 'features',
  demoLink: 'demoLink',
  websiteUrl: 'websiteUrl',
  price: 'price',
  offerings: 'offerings',
  targetCustomers: 'targetCustomers',
  customTargetCustomers: 'customTargetCustomers',
  interestedIn: 'interestedIn',
  faqs: 'faqs',
  rawProductData: 'rawProductData',
  isClaimed: 'isClaimed',
  isPublished: 'isPublished',
  isVerified: 'isVerified',
  isSponsored: 'isSponsored',
  launchedAt: 'launchedAt',
  scheduledAt: 'scheduledAt',
  viewsCount: 'viewsCount',
  createdAt: 'createdAt',
  companyId: 'companyId',
  productLaunchesId: 'productLaunchesId'
};

exports.Prisma.MediaV2ScalarFieldEnum = {
  id: 'id',
  type: 'type',
  objectPath: 'objectPath',
  createdAt: 'createdAt'
};

exports.Prisma.ProductScreenshotMediaScalarFieldEnum = {
  productId: 'productId',
  mediaV2Id: 'mediaV2Id',
  createdAt: 'createdAt'
};

exports.Prisma.ProductTagsScalarFieldEnum = {
  id: 'id',
  tagId: 'tagId',
  productV2Id: 'productV2Id',
  createdAt: 'createdAt'
};

exports.Prisma.ProductAdminScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  productId: 'productId',
  createdAt: 'createdAt'
};

exports.Prisma.ProductRegionScalarFieldEnum = {
  id: 'id',
  regionId: 'regionId',
  productId: 'productId'
};

exports.Prisma.ProductPlatformScalarFieldEnum = {
  id: 'id',
  android: 'android',
  ios: 'ios',
  windows: 'windows',
  mac: 'mac',
  linux: 'linux',
  web: 'web',
  productId: 'productId'
};

exports.Prisma.ProductContactOptionScalarFieldEnum = {
  id: 'id',
  email: 'email',
  phoneNumber: 'phoneNumber',
  whatsapp: 'whatsapp',
  productId: 'productId'
};

exports.Prisma.ProductCommentScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  content: 'content',
  legacyContent: 'legacyContent',
  customContent: 'customContent',
  version: 'version',
  productId: 'productId',
  authorId: 'authorId',
  parentCommentId: 'parentCommentId',
  totalViews: 'totalViews',
  totalReactions: 'totalReactions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rawCommentData: 'rawCommentData',
  rawMetaData: 'rawMetaData'
};

exports.Prisma.ProductVoteScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  productId: 'productId',
  createdAt: 'createdAt'
};

exports.Prisma.ProductCommentReactionScalarFieldEnum = {
  id: 'id',
  commentId: 'commentId',
  userId: 'userId',
  type: 'type',
  createdAt: 'createdAt'
};

exports.Prisma.ProductCommentsMediaScalarFieldEnum = {
  productCommentId: 'productCommentId',
  mediaV2Id: 'mediaV2Id',
  createdAt: 'createdAt'
};

exports.Prisma.IntegrationTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  integrationType: 'integrationType',
  integrationId: 'integrationId'
};

exports.Prisma.ProductIntegrationTagScalarFieldEnum = {
  id: 'id',
  integrationTagId: 'integrationTagId',
  productId: 'productId'
};

exports.Prisma.ProductDraftScalarFieldEnum = {
  id: 'id',
  title: 'title',
  userId: 'userId',
  draftData: 'draftData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productId: 'productId'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  parentId: 'parentId',
  rank: 'rank',
  createdAt: 'createdAt',
  type: 'type',
  createdBy: 'createdBy'
};

exports.Prisma.TagContextScalarFieldEnum = {
  contextName: 'contextName',
  tagId: 'tagId'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  communityId: 'communityId',
  channelId: 'channelId',
  amount: 'amount',
  discount: 'discount',
  paymentType: 'paymentType',
  status: 'status',
  stripePaymentId: 'stripePaymentId',
  stripeSessionId: 'stripeSessionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TicketScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  slug: 'slug',
  amount: 'amount',
  status: 'status',
  stripePaymentId: 'stripePaymentId',
  stripeSessionId: 'stripeSessionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  communityId: 'communityId',
  channelId: 'channelId'
};

exports.Prisma.AVCTicketRegistrationScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  company: 'company',
  position: 'position',
  address: 'address',
  country: 'country',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
  industry: 'industry',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ticket: 'ticket',
  authorId: 'authorId',
  paymentId: 'paymentId'
};

exports.Prisma.CityScalarFieldEnum = {
  id: 'id',
  name: 'name',
  countryIso: 'countryIso'
};

exports.Prisma.ProductReviewScalarFieldEnum = {
  id: 'id',
  createdBy: 'createdBy',
  reviewedBy: 'reviewedBy',
  productId: 'productId',
  title: 'title',
  summary: 'summary',
  startDate: 'startDate',
  endDate: 'endDate',
  usageFrequency: 'usageFrequency',
  reviewAs: 'reviewAs',
  supportRating: 'supportRating',
  valueRating: 'valueRating',
  functionalityRating: 'functionalityRating',
  overallRating: 'overallRating',
  isFeatured: 'isFeatured',
  isVisible: 'isVisible',
  reviewerDesignation: 'reviewerDesignation',
  metaData: 'metaData',
  additionalQuestions: 'additionalQuestions',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.ProductReviewEmailScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  email: 'email',
  createdAt: 'createdAt',
  invitedFrom: 'invitedFrom'
};

exports.Prisma.MiscellaneousScalarFieldEnum = {
  id: 'id',
  type: 'type',
  jsonValue: 'jsonValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UnsubscribeEmailScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  reason: 'reason',
  createdAt: 'createdAt'
};

exports.Prisma.JobScalarFieldEnum = {
  id: 'id',
  title: 'title',
  company: 'company',
  location: 'location',
  country: 'country',
  duration: 'duration',
  isRemote: 'isRemote',
  featured: 'featured',
  tags: 'tags',
  applyLink: 'applyLink',
  logo: 'logo',
  lastUpdated: 'lastUpdated',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isVisible: 'isVisible',
  authorId: 'authorId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.LocationType = exports.$Enums.LocationType = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  HYBRID: 'HYBRID'
};

exports.EventType = exports.$Enums.EventType = {
  SUMMIT: 'SUMMIT',
  CONFERENCE: 'CONFERENCE',
  MEETING_MEETUP: 'MEETING_MEETUP',
  TRADE_SHOW: 'TRADE_SHOW',
  REVERSE_TRADE_SHOW: 'REVERSE_TRADE_SHOW',
  VIRTUAL_DEMO_DAY: 'VIRTUAL_DEMO_DAY',
  BUSINESS_EXCHANGE: 'BUSINESS_EXCHANGE',
  FORUM: 'FORUM',
  SEMINAR: 'SEMINAR',
  EXPO: 'EXPO',
  CONVENTION: 'CONVENTION',
  WEBINAR: 'WEBINAR'
};

exports.LevelType = exports.$Enums.LevelType = {
  LOCAL: 'LOCAL',
  NATIONAL: 'NATIONAL',
  INTERNATIONAL: 'INTERNATIONAL'
};

exports.PinnedPostType = exports.$Enums.PinnedPostType = {
  CHANNEL: 'CHANNEL',
  COMMUNITY: 'COMMUNITY'
};

exports.Prisma.ModelName = {
  Product: 'Product',
  Vote: 'Vote',
  Comment: 'Comment',
  ProductMetaData: 'ProductMetaData',
  ProductPrivateData: 'ProductPrivateData',
  Founder: 'Founder',
  CustomerReview: 'CustomerReview',
  Category: 'Category',
  ParentCategory: 'ParentCategory',
  SubCategory: 'SubCategory',
  Region: 'Region',
  ProductsCategories: 'ProductsCategories',
  ProductsParentCategories: 'ProductsParentCategories',
  ProductsSubCategories: 'ProductsSubCategories',
  ProductsRegions: 'ProductsRegions',
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  UserProfile: 'UserProfile',
  UserUpgrade: 'UserUpgrade',
  IncognitoProfile: 'IncognitoProfile',
  FollowingProfiles: 'FollowingProfiles',
  FollowingParentCategories: 'FollowingParentCategories',
  FollowingFamilies: 'FollowingFamilies',
  VerificationToken: 'VerificationToken',
  ProductLaunches: 'ProductLaunches',
  DaySpotLight: 'DaySpotLight',
  Admin: 'Admin',
  Analytics: 'Analytics',
  NewsLetter: 'NewsLetter',
  Feedback: 'Feedback',
  TrendingNews: 'TrendingNews',
  CategoryLeader: 'CategoryLeader',
  LeaderBoard: 'LeaderBoard',
  UserNotifications: 'UserNotifications',
  Event: 'Event',
  EventRegistration: 'EventRegistration',
  OnlineUser: 'OnlineUser',
  Chat: 'Chat',
  ChatReport: 'ChatReport',
  ChatInfo: 'ChatInfo',
  ChatRules: 'ChatRules',
  ChatLinkedPage: 'ChatLinkedPage',
  ChatReadStatus: 'ChatReadStatus',
  PinnedChat: 'PinnedChat',
  Messages: 'Messages',
  MessageReaction: 'MessageReaction',
  BlockedUserFromChat: 'BlockedUserFromChat',
  VentureCapital: 'VentureCapital',
  InvestmentStageTag: 'InvestmentStageTag',
  FundTypeTag: 'FundTypeTag',
  SectorFocusTag: 'SectorFocusTag',
  VentureCapitalCompany: 'VentureCapitalCompany',
  VentureCapitalTeam: 'VentureCapitalTeam',
  VentureCapitalsCompanies: 'VentureCapitalsCompanies',
  VentureCapitalsInvestmentStageTags: 'VentureCapitalsInvestmentStageTags',
  VentureCapitalsFundTypeTags: 'VentureCapitalsFundTypeTags',
  VentureCapitalsSectorFocusTags: 'VentureCapitalsSectorFocusTags',
  DeviceToken: 'DeviceToken',
  PlatformOption: 'PlatformOption',
  Media: 'Media',
  PostMedia: 'PostMedia',
  PostCommentMedia: 'PostCommentMedia',
  TaggedProfile: 'TaggedProfile',
  TaggedProduct: 'TaggedProduct',
  Community: 'Community',
  CommunityMember: 'CommunityMember',
  CommunityMembershipRequest: 'CommunityMembershipRequest',
  CommunityInvite: 'CommunityInvite',
  CommunityLog: 'CommunityLog',
  Channel: 'Channel',
  ChannelNotificationSetting: 'ChannelNotificationSetting',
  ChannelGuideline: 'ChannelGuideline',
  Post: 'Post',
  PinnedPost: 'PinnedPost',
  PostReaction: 'PostReaction',
  PostComment: 'PostComment',
  PostCommentReaction: 'PostCommentReaction',
  PressFormResponse: 'PressFormResponse',
  Company: 'Company',
  CompanyLocation: 'CompanyLocation',
  CompanySocialLink: 'CompanySocialLink',
  Investor: 'Investor',
  ProductV2: 'ProductV2',
  MediaV2: 'MediaV2',
  ProductScreenshotMedia: 'ProductScreenshotMedia',
  ProductTags: 'ProductTags',
  ProductAdmin: 'ProductAdmin',
  ProductRegion: 'ProductRegion',
  ProductPlatform: 'ProductPlatform',
  ProductContactOption: 'ProductContactOption',
  ProductComment: 'ProductComment',
  ProductVote: 'ProductVote',
  ProductCommentReaction: 'ProductCommentReaction',
  ProductCommentsMedia: 'ProductCommentsMedia',
  IntegrationTag: 'IntegrationTag',
  ProductIntegrationTag: 'ProductIntegrationTag',
  ProductDraft: 'ProductDraft',
  Tag: 'Tag',
  TagContext: 'TagContext',
  Payment: 'Payment',
  Ticket: 'Ticket',
  AVCTicketRegistration: 'AVCTicketRegistration',
  City: 'City',
  ProductReview: 'ProductReview',
  ProductReviewEmail: 'ProductReviewEmail',
  Miscellaneous: 'Miscellaneous',
  UnsubscribeEmail: 'UnsubscribeEmail',
  Job: 'Job'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
